(ns common.schema.entities.message
  (:require
   [common.schema.entities.related-entities :as related-entities]
   [common.schema.entities.activity :as activity]
   [common.schema.entities.message-options :as message-options]))

(defonce import-fixed-fields [:note-message/message])

(def new-message
  (concat [[:note-message/message
            {:field/data-type          :data.type/text-richtext
             :field/default-authorization {:access/read  :role/guest-buy-side
                                           :access/write :role/guest-buy-side}
             :field/default-visibility {:editor :editor.type/none
                                        :grid   :editor.type/none
                                        :filter :filter.type/text
                                        :field-visibility :in-use}
             :field/translations       {:en "Message"}}]
           [:note-message/type
            {:field/data-type :data.type/keyword
             :field/default-authorization {:access/read  :role/guest-buy-side
                                           :access/write :role/guest-buy-side}
             :field/default-visibility {:editor :editor.type/radio
                                        :grid   :editor.type/radio
                                        :filter :filter.type/boolean
                                        :field-visibility :in-use}
             :options [{:key   :outbound
                        :label "Outbound"}
                       {:key   :inbound
                        :label "Inbound"}]
             :field/translations {:en "Type"}}]
           [:note-message/timestamp
            {:field/data-type          :data.type/date
             :field/default-authorization {:access/read  :role/guest-buy-side
                                           :access/write :role/guest-buy-side}
             :field/default-visibility {:editor :editor.type/date
                                        :grid   :editor.type/date
                                        :filter :filter.type/date
                                        :field-visibility :in-use}
             :field/translations       {:en "Date"}}]
           [:note-message/message-type
            {:field/data-type :data.type/keyword
             :field/default-authorization {:access/read  :role/guest-buy-side
                                           :access/write :role/guest-buy-side}
             :value-type :keyword
             :field/not-clearable? true
             :field/default-visibility {:editor :editor.type/select
                                        :grid   :editor.type/select
                                        :filter :filter.type/select
                                        :field-visibility :in-use}
             :options message-options/options
             :field/translations {:en "Message type"}}]]
          activity/new-activity
          related-entities/related-entities))
